(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-ugc"] && !Shopify.designMode) return;
  try {
    
  var elem = document.querySelector('.ugc__images');
  var flkty = new Flickity( elem, {
    // options
    cellAlign: 'left',
    contain: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-skin-concern-blocks"]) return;
  try {
    
// Send GA event when shop all block is clicked
$('.cta__shop-all').click(function(){
  
  	var label = $(this).attr('title');
  
  	ga('send', 'event', {
      eventCategory: 'Page Link',
      eventAction: 'CTA',
      eventLabel: label
    });
  
    console.log('send GA event: Page Link > CTA > ' + label );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-skin-type-blocks"]) return;
  try {
    
// Send GA event when shop all block is clicked
$('.cta__shop-all').click(function(){
  
  	var label = $(this).attr('title');
  
  	ga('send', 'event', {
      eventCategory: 'Page Link',
      eventAction: 'CTA',
      eventLabel: label
    });
  
    console.log('send GA event: Page Link > CTA > ' + label );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-skin-type-overview"]) return;
  try {
    
// Send GA event when skin type is clicked
$('.skin-type a').click(function(){
  
  	var label = $(this).attr('title');
  
  	ga('send', 'event', {
      eventCategory: 'Page Link',
      eventAction: 'CTA',
      eventLabel: label
    });
  
    console.log('send GA event: Page Link > CTA > ' + label );
});

  } catch(e) { console.error(e); }
})();
})();
